import { Link } from "react-router-dom";
import { useState } from "react";
import styles from "../../pages/DashBoard/AllUsers.module.css";

const Menu = (props) => {
    const [pos, setpos] = useState(0)
    const MenuLinks = [
        { name: "All Users", link: "all_users" },
        { name: "Pending Onboarding", link: "pending_onboarding" },
        { name: "Link Expired", link: "link_expired" },
        { name: "Pending Documents", link: "pending_documents" },
        { name: "Completed", link: "completed" },
        { name: "Dropped", link: "dropped" }
    ]
    function handleTabClick(pos){
      setpos(pos)  
      props.menuClick(MenuLinks[pos])
    }
    return (
        <div className={styles.navItemParent}>
            {MenuLinks.map((i, index) => {
                return (
                    <div className={pos === index ? styles.navItemSelected : styles.navItem} key={index} onClick={() => handleTabClick(index)}>
                        <div className={styles.text}> <span to={i.link} className={styles.link}>{i.name}</span ></div>
                    </div>
                )
            })}
        </div>
    )
}
export default Menu;